import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class TipoDTEService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetTiposDocumento(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_dte {
            obtenerTodos {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_dte.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
    GetByTipoDte(tipo_filtro_dte = 1, callback) {
        this.gqlclient.query({
            query: gql `
        query($tipo_filtro_dte:Int)
        {
          tipo_dte {
            obtenerSegunTipoDte(filtro: {exacto: {tipo_filtro_dte: $tipo_filtro_dte}}) {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  es_tributario
                  afecta_nc
                  afecta_nd
                  afecta_libro_compra
                  afecta_libro_venta
                  es_exento
                }
              }
            }
          }
        }
        `,
            variables: {
                tipo_filtro_dte: tipo_filtro_dte
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_dte.obtenerSegunTipoDte;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTipoCompra(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_dte {
            obtenerTipoCompra {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombre
                  codigo
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_dte.obtenerTipoCompra;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTipoDocGarantia(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_garantia {
            obtenerSegunFiltro(filtro: {exacto: {activado: true, nombre:""}}) {
              mensajes {
                tipo
                texto
                codigo
                contexto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  activado
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_garantia.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTipoCompraRecepcionDoc(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_dte {
            obtenerTipoCompraRecepcionDoc {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombre
                  codigo
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_dte.obtenerTipoCompraRecepcionDoc;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTipoItem(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: tipo_itemInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          tipo_item {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  nombre
                  activo
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
            variables: inputParams
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_item.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTipoDteSegunId(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query($entidad: tipo_dteInputType) {
          tipo_dte{
            obtenerSegunId(entidad: $entidad) {
             respuesta{
              codigo
              nombre
            }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
            variables: inputParams
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_dte.obtenerSegunId;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerTipoDocOrderCompra(callback) {
        this.gqlclient.query({
            query: gql `
        {
          tipo_dte {
            obtenerTipoDocOrderCompra {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  nombre
                  codigo
                }
              }
            }
          }
        }
        `,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.tipo_dte.obtenerTipoDocOrderCompra;
            callback({ mensajes, respuesta });
        });
    }
}
TipoDTEService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TipoDTEService_Factory() { return new TipoDTEService(i0.ɵɵinject(i1.GraphQLClient)); }, token: TipoDTEService, providedIn: "root" });
